<template>
  <config-base :show-plan-details="showPlanDetails" :plan-details-label="planDetailsLabel" class="opc-sdk" @view-details="handleViewDetails">
    <div slot="config" class="opc-sdk__config">
      <zm-radio-group :value="selectedPlanCode" :enter-select="true" @input="onPlanSelect" ref="radioGroup"
          aria-label="Video SDK Plan" class="opc-addon-config__main__plan opc-card-radio">
          <zm-radio data-testid="checkout-radio-81" v-for="plan in planList" :key="plan.plan_code" :label="plan.plan_code">
            <p class="opc-addon-config__main__plan__capacity">
              {{ $t('billing.pay_you_go')}}
              <span 
                class="opc-addon-config__main__plan__capacity-recommend">
                {{ planDesc }}
              </span>
            </p>
            <p class="opc-addon-config__main__plan__price">
              <span class="opc-addon-config__main__plan__price--amount">{{ $money(plan.excessPrice, { forceDiff: true })
              }}</span>
              <span class="opc-addon-config__main__plan__price--unit">/ {{$t('billing.video_sdk.unit')}}<priceVATTip /></span>
            </p>
          </zm-radio>
        </zm-radio-group>
        <p class="opc-sdk__config-switch">{{ $t('billing.video_sdk.switch_plan_to_universal') }}
          <span data-testid="checkout-span-82" tabindex="0" @click="handleSwitch">{{ $t('billing.video_sdk.switch_now') }}</span></p>
    </div>
    <template #footer v-if="canRmv">
      <zm-button data-testid="checkout-button-83" type="link" ghost @click="removePlanByKey" :aria-label="'remove ' + trackingPlanName + ' plan'">
        {{ $t('billing.common.remove') }}
      </zm-button>
    </template>
  </config-base>
</template>

<script type="text/jsx">
import {  mapGetters, mapMutations } from 'vuex';
import plansMixin from '@/plans/mx/plan';
import ConfigBase from '@/components/config-base';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import PlanDetails from '../dialog/plan-details';
import commonMixin from '@/plans/VIDEO_SDK/mixin';
import AddonMixin from '@/plans/mx/addon';
import { toThousands } from '@/utils/money';
import { translation } from '@/plugins/i18n';
import UsageTypeMixins from '@/views/checkout/address/mx-usage-type';
import { getDefaultFlowType } from '@/common/service/page-config';

const ConfigBaseComp = {
  name: 'sdk-base',
  extends: ConfigBase,
  mixins: [commonMixin],
  props: {
    showPlanDetails: Boolean,
    planDetailsLabel: String,
  },
  data() {
    return {
      showLearnMore: false,
    };
  },
  methods:{
    mx_renderLicense(plan) {
      if (!plan.cartInfo.selected_number) return;
      return <li>{translation('billing.pay_you_go')}</li>;
    },
    mx_renderCycle(plan) {
      return <li>
            <span>
              {this.$money(plan.amount + (plan?.esmd_amount || 0))}
              <span>&nbsp;{translation('billing.upfront')}</span>
            </span>
      </li>;
    },
  }
};

export default {
  mixins: [plansMixin, commonMixin, AddonMixin, UsageTypeMixins],
  components: {
    ConfigBase: ConfigBaseComp,
  },
  data() {
    return {
      selectedNumber: 1,
      selectedPlanCode:'',
      planDetailsDialog: new ServiceConfirm(PlanDetails, this.$store),
      planDesc: translation('billing.video_sdk.free_min',[toThousands(10000)])
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlansMap', 'planMapFlat', 'getUserCurrentSubscriptions', 'getCurrentBasePlanInfo', 'getTypeGroupSelectedPlans', 'boughtPlans']),
    planList() {
      return this.planMapFlat.filter((p) => {
        const isCurrentPlanType = p.type === this.planType;
        const isCurrentCategory = p.category === this.selectedPlan.category
        return isCurrentPlanType && isCurrentCategory
      });
    },
    selectedPlan() {
      return this.getTypeGroupSelectedPlans[this.planType]?.[0];
    },
    sdkAsBasePlan() {
      return this.getCurrentBasePlanInfo.planType === this.planType;
    },
    canRmv() {
      return false;
    },
    showPlanDetails() {
      return true;
    },
    planDetailsLabel() {
      return '';
    },
    additionalSpans() {
      return {};
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    async handleViewDetails() {
      this.$tracking.buyInteraction('plan details selected', this.trackingPlanName);
      await this.planDetailsDialog.confirm({ planCategory: this.selectedPlan.category });
    },
    handleSwitch() {
      const type = getDefaultFlowType();
      this.$tracking.buyInteraction('explore other plans', `${this.trackingPlanName} - switch now to zoom sdk universal credit`);
      location.href = `/opc/buy?plan=zsdkuc&type=${type}`;
    },
  },
  created() {
    const selectedPlan = this.selectedPlan;

    if (selectedPlan) {
      this.billingCycle = selectedPlan.billing_cycle;
      this.selectedNumber = selectedPlan.cartInfo?.selected_number;
      this.selectedPlanCode = selectedPlan.plan_code;

    }
  },
  mounted(){
  }
};
</script>

<style lang="scss">
.opc-sdk {
  &__quantity-selector{
    margin-bottom: 10px;
  }
  .opc-sdk__config{
    .zm-radio {
      flex: 0 0 calc(100% - 8px);
    }
    &-switch{
      margin: 30px 0 0;
      color: #666487;
      span {
        color: #0B5CFF;
        cursor: pointer;
        font-weight: 500
      }
    }
  }
}
</style>
